<template>
  <el-form
    ref="form"
    :model="$props.accountContact"
    :rules="rules"
    label-position="left"
    label-width="130px"
  >
    <el-form-item
      label="Name"
      prop="name"
    >
      <el-input
        v-model="$props.accountContact.name"
        clearable
      />
    </el-form-item>

    <el-form-item
      label="Type"
      prop="contact_type"
    >
      <el-select
        v-model="$props.accountContact.contact_type"
        :loading="loading"
        value-key="long"
        class="w-100"
      >
        <el-option
          v-for="type in types"
          :key="type.id"
          :label="type.long"
          :value="type"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="Position">
      <el-input
        v-model="$props.accountContact.title"
        clearable
      />
    </el-form-item>

    <el-form-item label="Telephone">
      <el-input
        v-model="$props.accountContact.phone"
        clearable
      />
    </el-form-item>

    <el-form-item label="Mobile">
      <el-input
        v-model="$props.accountContact.mobile"
        clearable
      />
    </el-form-item>

    <el-form-item label="Email">
      <el-input
        v-model="$props.accountContact.email"
        clearable
      />
    </el-form-item>

    <el-form-item label="Include Billing">
      <el-switch
        v-model="$props.accountContact.include_billing"
        :disabled="!$props.accountContact.email"
      />
    </el-form-item>

    <el-form-item label="Include Pickups">
      <el-switch
        v-model="$props.accountContact.include_pickups"
        :disabled="!$props.accountContact.email"
      />
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    accountContact: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      rules: {
        name: [
          { required: true, message: 'Name is required', trigger: 'blur' }
        ],
        contact_type: [
          { required: true, message: 'Type is required', trigger: 'change' }
        ]
      },
      loading: true,
      types: []
    }
  },
  created () {
    this
      .$sdk
      .dictionary_contacttype
      .list(request => {
        request.limit = 100
      })
      .then(types => { this.types = types })
      .finally(() => { this.loading = false })
  },
  methods: {
    validate (callback) {
      this.$refs['form'].validate(callback)
    }
  }
}
</script>
